<div class="card">
  <div class="flex flex-column h-full">
    <div class="grid flex-auto p-2">
      <div class="col-6">
        <div class="text-pick-up-colour font-bold">
          <i class="vme-material-icons">&#xe805;</i> Pick-up
        </div>

        <div *ngIf="pickupLocation" class="font-bold text-gray-600">
          <div>
            <div>{{ pickupLocation.businessName }}</div>
            <div
              *ngFor="
                let item of pickupLocation.primaryAddress
                  .replace(pickupLocation.postcode, '')
                  .split(',')
              "
            >
              {{ item }}
            </div>
            <div>{{ pickupLocation.postcode | postcode }}</div>
            <div *ngIf="pickupLocation.what3Words">
              <what3words-logo></what3words-logo
              ><span class="what3words-value">{{ pickupLocation.what3Words }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="text-drop-off-colour font-bold">
          <i class="vme-material-icons">&#xe804;</i> Drop-off
        </div>

        <div *ngIf="dropoffLocation" class="font-bold text-gray-600">
          <div>
            <div>{{ dropoffLocation.businessName }}</div>
            <div
              *ngFor="
                let item of dropoffLocation.primaryAddress
                  .replace(dropoffLocation.postcode, '')
                  .split(',')
              "
            >
              {{ item }}
            </div>
            <div>{{ dropoffLocation.postcode | postcode }}</div>
            <div *ngIf="dropoffLocation.what3Words">
              <what3words-logo></what3words-logo
              ><span class="what3words-value">{{ dropoffLocation.what3Words }}</span>
            </div>
          </div>
        </div>
      </div>

      <div *ngFor="let group of dateTimeColumnGroups" class="col-6">
        <div *ngFor="let col of group" class="mb-4">
          <div>
            <i class="vme-material-icons text-sm" [ngClass]="col.iconClass">&#xe800;</i>
            {{ col.title }}
          </div>

          <div class="font-bold text-gray-600">
            {{ col.date | datex : "ddd DD MMM 'YY" }} {{ col.date | datex : 'HH:mm' }}
          </div>
        </div>
      </div>

      <ng-container *ngIf="this.task.isRescheduled && originalDateTimeColumnGroups.length > 0">
        <div class="original-dates col-12">Original Dates/Times:</div>

        <div *ngFor="let group of originalDateTimeColumnGroups" class="col-6">
          <div *ngFor="let col of group" class="mb-4">
            <div>
              <i class="vme-material-icons text-sm" [ngClass]="col.iconClass">&#xe800;</i>
              {{ col.title }}
            </div>

            <div class="font-bold text-gray-600">
              {{ col.date | datex : "ddd DD MMM 'YY" }} {{ col.date | datex : 'HH:mm' }}
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="flex-initial mt-4" *ngIf="!hideTaskSchedule">
      <div class="w-full text-center font-bold mb-3">Scheduled Collection & Delivery</div>
      <task-supplier-schedule-timeline
        *ngIf="taskSupplierScheduleStore"
        [taskSupplierScheduleStore]="taskSupplierScheduleStore"
      ></task-supplier-schedule-timeline>
    </div>
  </div>
</div>
